import styles from './McAnswerDistributionBadges.module.css';

interface McAnswerDistributionBadgesProps {
  correctIndex?: number;
  optionIndex: number;
  value: number;
}

function formatPercentage(value: number) {
  return `${(value * 100).toFixed(1)}%`;
}

export function McAnswerDistributionBadges({
  correctIndex,
  optionIndex,
  value,
}: McAnswerDistributionBadgesProps) {
  const isCorrect = correctIndex === optionIndex;
  const hasSelections = value > 0;

  return (
    <span
      aria-label={`${formatPercentage(value)} of students selected this option`}
      className={styles.badge}
      data-state={
        isCorrect
          ? 'correct'
          : hasSelections
            ? 'selected'
            : 'neutral'
      }
    >
      {isCorrect ? <span aria-hidden="true">✓</span> : null}
      <span>{formatPercentage(value)}</span>
    </span>
  );
}
